import { Injectable, OnDestroy } from '@angular/core';
import { filter, fromEvent, Observable, map, Subject, takeUntil } from 'rxjs';
import { ConsoleLogger } from '../shared/console-logger';
import { v4 as uuidv4 } from 'uuid';
import { ChannelEvent } from '../models/channel-event.model';
import { AuthService } from './auth.service';
import { UserLoginModel } from '../models/user-login.model';

@Injectable({ providedIn: 'root' })
export class ChannelService implements OnDestroy {
  private readonly ngUnsubscribe = new Subject();
  private static readonly PORTAL_GUID = uuidv4();
  private readonly channel: BroadcastChannel = new BroadcastChannel('fss_portal_channel');
  private readonly channelMessages$: Observable<ChannelEvent> = fromEvent(this.channel, 'message')
    .pipe(
      map((event: any) => event.data),
      filter((event: ChannelEvent) => {
        const ulm: UserLoginModel = this.authService.getUserLogin();
        if (ulm) {
          return event['appId'] === ulm.getAppId()
              && event['siteGuid'] === ulm.getSiteGuid()
              && event['userGuid'] === ulm.getSub();
        }
        return false;
      }),
      takeUntil(this.ngUnsubscribe)
    );

  constructor(private authService: AuthService) {
    ConsoleLogger.debug('Channel - PortalID: ' + this.getPortalId());
    this.channelMessages$.subscribe((ev: ChannelEvent) => this.handleChannelEvent(ev));
  }

  public ngOnDestroy(): void {
    this.ngUnsubscribe.next(undefined);
    this.ngUnsubscribe.complete();
  }

  public getPortalId(): string {
    return ChannelService.PORTAL_GUID;
  }

  public sendChannelEvent(event: ChannelEvent) {
    // ConsoleLogger.debug('Channel - Sending event: ' + JSON.stringify(event));
    if (event) {
      const ulm: UserLoginModel = this.authService.getUserLogin();
      event['appId'] = ulm?.getAppId();
      event['siteGuid'] = ulm?.getSiteGuid();
      event['userGuid'] = ulm?.getSub();
      event['portalId'] = this?.getPortalId();

      this.channel.postMessage(event);
    }
  }

  private handleChannelEvent(event: ChannelEvent) {
    ConsoleLogger.debug('Channel - Event received: ' + JSON.stringify(event));
  }

}
